<template>
    <div class="pricemark-container">
        <span @click="clickRefresh" style="color:blue;font-size:13px;cursor: pointer;">【点击刷新】</span>
        <vggrid :random="Math.floor(Math.random() * 999999)" :list="pxertlist" tableheight="600" flexname="" :cols="cols"
                :showfooter="false" :showPage="false" :resizable="true"
                :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
        >
        </vggrid>
    </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'

  export default {
    name: 'pexpertList',
    components: {vggrid},
    mixins: [common],
    props: {
      projectid: {},
      project: {
        default: {}
      },
      activeName: {
        default: ''
      }
    },
    watch: {
      activeName: {
        handler (newVal) {
            if(this.activeName === 'zjxx') {
                this.getPerctList()
            }
        },
	      deep: true,
          immediate: true
      }
    },
    data () {
      return {
        pxertlist: [],
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols:[
          {field: 'pexpertlogincode', fieldtype: 'I', title: '评审号', calculExpr: ''},
          {field: 'pexpertname', fieldtype: 'C', title: '姓名', calculExpr: ''},
          {field: 'pexpertmobile', fieldtype: 'I', title: '手机', calculExpr: ''},
          {field: 'pexpertidcode', fieldtype: 'T', title: '身份证', calculExpr: ''},
          {field: 'pexpertemployer', fieldtype: 'T', title: '工作单位', calculExpr: ''},
          {field: 'pexpertposition', fieldtype: 'T', title: '职称/职务', calculExpr: ''},
          {field: 'pexpertroletypeCN', fieldtype: 'T', title: '评审角色', calculExpr: ''},
          {field: 'pexpertStatus', fieldtype: 'T', title: '状态', calculExpr: ''}
        ]
      }
    },
    created () {
    },
    activated(){
    },
    methods: {
      async cellClick (row) {
        this.model = row
      },
      async viewProject(row) {
        this.model = row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
      },
      async getPerctList(){
        let res = await request({
            method: 'get',
            url: 'expert/getPerctList',
            params: {pexpertprojectid: this.projectid}
        })
        res.forEach(e => {
          e.pexperttypeCN = Number(e.pexperttype) === 1?'采购人':'评审人'
          e.pexpertroletypeCN = Number(e.pexpertroletype) === 1?'组长':'组员'
          e.pexpertStatus = e.pexpertmobile?'就绪':'准备'
        });
        this.pxertlist = res
      },
      async clickRefresh(){
        await this.getPerctList()
      }
    }
  }
</script>


<style lang="scss" scoped>
.con{
  background-color: #fff;
  padding: 10px 10px;
}
</style>
